var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-full overflow-auto"},[(_setup.operationStore?.operationData)?_c('router-view'):_c('div',[_vm._v(_vm._s(_setup.waitForComponent))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }